import { Component, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { slideInAnimation } from '@app/app-routing.animation';
import { SaidaAutenticacao } from '@app/models/Autenticacao/SaidaAutenticacao.model';
import { ContaService } from '@app/services/conta.service';
import { AuthAdminGuard } from './helpers/auth-admin.guard';
import { UtilService } from './services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css'],
  animations: [slideInAnimation]
})

export class AppComponent {
  @HostListener('document:click', ['$event']) 
  onMouseMove(e) {
    this.adminGuard.funcaoSolicitarExtensaoSessao();
    //console.log(e);
  }
  
  constructor(public router: Router, 
              public titleService: Title, 
              public contaService: ContaService, 
              public utilService: UtilService, 
              public adminGuard: AuthAdminGuard, 
              public dialog: MatDialog) {
    this.contaService._eventoLogin.subscribe((objetoSaidaAutenticacao: SaidaAutenticacao) => {
      this.funcaoMonitorarSessaoExpirada();
    });
    this.contaService.funcaoTentarRestaurarSessao();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.id == 1) {
          //this.mapaService.funcaoEstadoDestruir();
        }
        else if (event.url.startsWith('/mapa')) {
        }
      }
      else if (event instanceof NavigationEnd) {
        //this._service.SalvarEstado();
      }
    });
  }

  funcaoEfetuarLogout(): void {
    this.contaService.funcaoEfetuarLogout();
  }

  funcaoDeterminarSeInformacoesAutenticacaoPresentes = () => {
    this.contaService?.funcaoObterInformacoesAutenticacao()?.nomeUsuario != "";
  }

  funcaoSolicitarExtensaoSessao = () => {
    this.adminGuard.funcaoSolicitarExtensaoSessao();
  }

  dialogAberto = false;
  dialogRef: MatDialogRef<DialogSessao, any> = null;
  funcaoMonitorarSessaoExpirada = () => {
    //console.log(dataHoraAtual.getTime());
    //console.log(this.adminGuard.funcaoObterDataRequisicaoAnterior().getTime());
    //console.log(this.adminGuard.funcaoObterDataAviso().getTime());

    if (this.contaService?.funcaoObterInformacoesAutenticacao()) {
      var dataHoraAtual: Date = new Date();
      if (dataHoraAtual.getTime() > this.adminGuard.funcaoObterDataRequisicaoAnterior().getTime()) {
        if (this.dialogAberto) {
          this.dialogRef.close();
          this.dialogAberto = false;
        }
        this.contaService?.funcaoEfetuarLogout();
      }
      else if (dataHoraAtual.getTime() > this.adminGuard.funcaoObterDataAviso().getTime()) {
        if (!this.dialogAberto) {
          var config = { width: '600px' };
          this.dialogRef = this.dialog.open(DialogSessao, config);
          this.dialogAberto = true;

          this.dialogRef.afterClosed().subscribe(result => {
            this.dialogAberto = false;
          });
        }
      }
    }

    setTimeout(() => { this.funcaoMonitorarSessaoExpirada() }, 60 * 1000);
  }
}

@Component({
  selector: 'sessao',
  templateUrl: 'sessao.html',
})
export class DialogSessao {
  constructor(public dialogRef: MatDialogRef<DialogSessao>, public contaService: ContaService, public adminGuard: AuthAdminGuard) { }

  funcaoSolicitarExtensaoSessao = () => {
    this.contaService.funcaoTentarRestaurarSessao(false);
    this.adminGuard.funcaoSolicitarExtensaoSessao();
    this.dialogRef.close(true);
  }

  funcaoIgnorar = () => {
    this.dialogRef.close(false);
  }
}
